export const dateFormatString = 'YYYY-MM-DD';
export const timeFormatString = 'HH:mm:ss';
export const emailExpression =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const phoneExpression = /^\+?(?:[0-9] ?){6,14}[0-9]$/;
export const thumborBaseUrl = 'https://cdn.winerist.com/unsafe'; // No trailing slash
